<template>
    <div>
        <breadcrumbs :breadcrumbs="items" class="mt-2"></breadcrumbs>
    </div>
</template>

<script>
	import breadcrumbs from "../global/breadcrumbs";

    export default {
    	components: {
		    breadcrumbs
        },
	    props: {
		    breadcrumbs: {
			    type: Array,
			    required: true
		    }
	    },
        computed: {
    		items () {
    			return [
				    {
					    text: 'Pocetna',
					    disabled: false,
					    href: 'https://cms.rs.sr/',
				    },
                    ...this.breadcrumbs
                ]
            }
        }
    }
</script>
